<template>
    <button :class="classes" class="btn waves-effect waves-light" v-on:click.prevent="confirmDelete" v-html="label"></button>
</template>
<script>
import swal from 'sweetalert2'
import 'sweetalert2/dist/sweetalert2.css'

export default{
    props: {
        path: {
            default: '/'
        },
        index: {
            default: null
        },
        item: {
            default: {}
        },
        title: {
            default: 'name'
        },
        label: {
            default: '<i class="icon-bin"></i>'
        },
        classes: {
            default: 'btn-icon btn-xs btn-danger'
        }
    },
    data () {
        return {
            term: '',
            results: []
        }
    },
    methods: {
        confirmDelete: function () {
            let index = this.index
            let parnt = this

            swal({
                title: 'Deleting ' + this.item[this.title],
                text: "Are you sure? You won't be able to revert this!",
                type: 'warning',
                useRejections: true,
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then(function () {
                parnt.axios.delete(parnt.path + parnt.item.id)
                .then(
                    swal(
                        'Deleted!',
                        parnt.item[parnt.title] + ' has been deleted.',
                        'success'
                    ).then(function () {
                        parnt.$emit('remove', index)
                    }).catch(swal.noop)
                )
            }).catch(swal.noop)
        }
    }
}
</script>



// WEBPACK FOOTER //
// ConfirmDelete.vue?5a479fbf